import { ChangeDetectionStrategy, Component, HostBinding, Inject, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import {
    ACCA_BOOST_LAYOUT_PROVIDER,
    AccaBoostLayoutProvider,
    LadderNotification,
    MaxRewardNotification,
    isLadderNotification as isLadderNotificationExternal,
} from '../../../model';
import { BaseAccaBoostComponent } from '../../base-acca-boost.component';

@Component({
    selector: 'bs-acca-boost-ladder',
    templateUrl: './acca-boost-ladder.component.html',
    styleUrls: ['./acca-boost-ladder.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AccaBoostLadderComponent extends BaseAccaBoostComponent {
    @Input() notification: LadderNotification | MaxRewardNotification;
    @Input() usLadderEnabled: boolean;

    @HostBinding('class') className = 'acca-boost-module acca-boost-ladder';

    isLadderNotification = isLadderNotificationExternal;

    constructor(
        public siteCore: Sitecore,
        @Inject(ACCA_BOOST_LAYOUT_PROVIDER) layoutService: AccaBoostLayoutProvider,
    ) {
        super(layoutService);
    }
}
